
export default {
  name: 'CardInfoNumber',
  props: {
    cardInfoNumber: {
      type: Object,
      default: () => {},
    },
  },
}
